const getters = {
  getContactEmployerData: (state) => (employerId) => {
    const employerFound = state.employersAndRoleList.find(
      (employer) => employer.employerId == employerId,
    );
    if (employerFound == undefined) {
      return '';
    }

    return employerFound;
  },
  getContactEmployerRoleData: (state) => (employerId, employerRoleId) => {
    const employerFound = state.employersAndRoleList.find(
      (employer) => employer.employerId == employerId,
    );

    if (employerFound == undefined) {
      return '';
    }

    const employerRoleFound = employerFound.roles.find(
      (role) =>
        role.employerId == employerId && role.employerRoleId == employerRoleId,
    );

    if (employerRoleFound == undefined) {
      return '';
    }

    return employerRoleFound;
  },

  getContactEmployerById: (state) => (employerId) => {
    const employerFound = state.employersAndRoleList.find(
      (employer) => employer.employerId == employerId,
    );
    if (!employerFound) return null;
    return employerFound;
  },
};

export default getters;
